<template>
  <div>
    <PaginationWells class="pagination-row--top"> </PaginationWells>
    <slot></slot>
    <PaginationWells class="pagination-row--bottom"> </PaginationWells>
  </div>
</template>

<script>
import PaginationWells from "@/components/wishlist/pagination/Wells.vue";

export default {
  components: {
    PaginationWells
  },
  name: "WishlistPagination",
  // data() {},
  created() {},
  methods: {}
};
</script>
